import React,{useState} from "react";
import './PhotoGal.css'
import Gallary2024 from '../../gallary2024.json'

function PhotoGal (){
    const [showAlbum,setShowAlbum] = useState(null);
    
    const showAlbumImages = (album) => {
        setShowAlbum(album);
    }
    const handleClose = () =>{
        setShowAlbum(null);
    }
    const [selectedImage, setSelectedImage] = useState(null);

    const handleImageSelected = (imageSrc) => {
        setSelectedImage(imageSrc);
    };

    const handleCloseImage = () => {
        setSelectedImage(null);
    };
    return(
        <div className="PhotoGal-container">
            <div className="album-container">
                {!showAlbum && (<h2 onClick={showAlbumImages}>Galley of WQD 2024</h2>)}
                
            </div>
            {showAlbum && (
                <div className="G2024">
                <span onClick={handleClose}>X</span>
                <div className="G2024-content">
                    {Gallary2024.map((photos)=>(
                        <div className="img-hold">
                            <img src={photos.path} alt="" key={photos.id} onClick={() => handleImageSelected(photos.path)}/>
                        </div>
                    ))}
                    {selectedImage && (
                        <div className='poppedimg' onClick={handleCloseImage}>
                            <img src={selectedImage} alt="Selected" />
                            <button className='close-button' onClick={handleCloseImage}></button>
                        </div>
                        )}
                </div>
            </div>
        )}
        </div>
    )
}

export default PhotoGal;